Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-wishlist-widget');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    var model = null, openWidget = false;

    wrapper.open = function () {
        $('.js-widget-trigger', $wrapper).addClass('x-open');
        $('.js-widget-container', $wrapper).addClass('x-expanded');

        openWidget = false;
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.WidgetOpened(Vendd.Widget.WishlistWidget));
    };

    wrapper.close = function () {
        $('.js-widget-trigger', $wrapper).removeClass('x-open');
        $('.js-widget-container', $wrapper).removeClass('x-expanded');
    };

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("wishlistWidget_A", model);
        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function (html) {
        $wrapper.html(html);

        var $list = $('.x-wishlist-list', $wrapper);
        var $items = $('.wishlist-item', $list);

        if ($items.length > 3) {
            $list.cycle({
                slides: '> li',
                fx: 'carousel',
                timeout: 0,
                prev: '.x-wishlist-widget .nav-btn.prev-vertical',
                next: '.x-wishlist-widget .nav-btn.next-vertical',
                log: false,
                carouselVertical: true,
                carouselVisible: 3,
                allowWrap: false,
                disabledClass: 'disabled'
            });
            $('.nav-btn', $wrapper).show().css("display", "block");
        }

        if (openWidget) {
            $('html, body').animate({ scrollTop: $wrapper.offset().top }, 600);
            wrapper.open();
        }
    }; 

    $wrapper.on('click', '.js-remove', function (e) {
        e.preventDefault();

        var $this = $(this);
        var $item = $this.closest('.wishlist-item');
        var id = $item.data('identifier');

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.Remove(id));
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.WishlistWidget, false));
    });

    /*
    $wrapper.on('click', '.js-widget-trigger', function (e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.hasClass('x-open')) {
            wrapper.close();
        } else {
            wrapper.open();
        }
    });
    */

    $wrapper.on('click', '.js-move-to-cart', function (e) {
        e.preventDefault();

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.MoveAllToCart());
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.WishlistWidget, false));
    });

    $wrapper.on('click', function (e) {
        e.stopPropagation();
    });

    wrapper.AddToWishlistSuccess = function (envelope) {
        var response = envelope.message.data;

        if (response.code === "OperationSuccesful") {
            /* Track Add To Wishlist */
            if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                    fbq('track', 'AddToWishlist');
                }
            }
            /* END Track Add To Wishlist */
            notyf.success(LhApp.Function.getText("Common:ProductAddedToWishlist"), "", { timeOut: 1500, showDuration: 600, hideDuration: 700 });
        }
    };

    wrapper.RemoveFromWishlistSuccess = function (envelope) {
        var response = envelope.message.data;

        if (response.code === "OperationSuccesful") {
            /* Track Remove From Wishlist */
            if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                    fbq('track', 'RemoveFromWishlist');
                }
            }
            /* END Track Remove From Wishlist */
            notyf.success(LhApp.Function.getText("Common:ProductRemovedFromWishlist"), "", { timeOut: 1500, showDuration: 600, hideDuration: 700 });
        }
    };

    wrapper.WishlistWarning = function (envelope) {
        var response = envelope.message.data;

        //warning message
        if (response.data && response.data.ErrorMessage) {
            notyf.warning(response.data.ErrorMessage, "", { timeOut: 1500, showDuration: 600, hideDuration: 700 });
        }

        //if requires authentication - open login widget
        if (response.code === "RequiresAuthenticationError") {          
            setTimeout(function () { $(".x-login-widget .js-widget-trigger").trigger('click'); }, 500);
            setTimeout(function () { $(".x-login-widget .x-login-form input[name ='username']").focus(); }, 900);           
        }
    };

    $('body').on('click', function (e) {
        wrapper.close();
    });

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data;
        wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.WidgetOpened, wrapper, function (envelope) {
        if (envelope.message.data.widgetName !== Vendd.Widget.WishlistWidget) {
            wrapper.close();
        }
    });

    // TODO: Review
    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.OpenWidget, wrapper, function (envelope) {
        if (envelope.message.data.widgetName === Vendd.Widget.WishlistWidget) {
            if (envelope.message.data.immediate === true)
                wrapper.open();
            else
                openWidget = true; // the next refresh will open it
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.AddSuccess, wrapper, wrapper.AddToWishlistSuccess);

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.RemoveSuccess, wrapper, wrapper.RemoveFromWishlistSuccess);

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Warning, wrapper, wrapper.WishlistWarning);

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, wrapper, function (envelope) {

        var isB2B = envelope.message.data.model.IsB2BUser;
        var isAuthenticated = envelope.message.data.model.IsAuthenticated

        if (isB2B && isAuthenticated && venddProjectConfigs.SiteIsLocked) {
            $wrapper.removeClass('site-is-locked');
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.GetModel());
        }
    });
});

